/* eslint-disable no-negated-condition */ /* eslint-disable quote-props */ import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { g } from "../const/globalThis";
if (!g.__I18N_CACHED) {
    g.__I18N_CACHED = {};
}
// keep quote
// eslint-disable-next-line prefer-destructuring
var __I18N_CACHED = g.__I18N_CACHED;
// Verify parameter presence.
__I18N_CACHED.PACKID_LIST = __I18N_CACHED.PACKID_LIST || [];
__I18N_CACHED.INDEX = __I18N_CACHED.INDEX || 0;
__I18N_CACHED.KEY_MAP = __I18N_CACHED.KEY_MAP || {};
__I18N_CACHED.VK_MAP = _instanceof(__I18N_CACHED.VK_MAP, Map) ? __I18N_CACHED.VK_MAP : new Map();
var NUM_HIDDEN = {
    "#": "⁯",
    "1": "‪",
    "2": "‎",
    "3": "⁦",
    "4": "⁨",
    "5": "⁡",
    "6": "⁢",
    "7": "⁣",
    "8": "⁤",
    "9": "⁥",
    "0": "⁮"
};
var NUM_SHOWED = {
    "⁯": "#",
    "‪": "1",
    "‎": "2",
    "⁦": "3",
    "⁨": "4",
    "⁡": "5",
    "⁢": "6",
    "⁣": "7",
    "⁤": "8",
    "⁥": "9",
    "⁮": "0"
};
var HIDDEN_REG = /[\u206F\u202A\u200E\u2066\u2068\u2061\u2062\u2063\u2064\u2065\u206E]/g;
function serialize(obj) {
    var fkv = {};
    var fkvs = [];
    [
        "copyKey",
        "packId",
        "type",
        "componentName",
        "isMatched",
        "packageName"
    ].forEach(function(key) {
        if (obj[key]) {
            fkv[key] = obj[key];
            fkvs.push("".concat(key, ":").concat(obj[key].toString()));
        }
    });
    return [
        fkv,
        fkvs.join(";")
    ];
}
/** 将信息转换成mapping index */ function set(VK) {
    var index;
    var _serialize = _sliced_to_array(serialize(VK), 2), fvk = _serialize[0], fkvkey = _serialize[1];
    if (!g.__I18N_CACHED.VK_MAP.has(fkvkey)) {
        index = ++g.__I18N_CACHED.INDEX;
        g.__I18N_CACHED.VK_MAP.set(fkvkey, index);
        g.__I18N_CACHED.KEY_MAP[index] = fvk;
    } else {
        index = g.__I18N_CACHED.VK_MAP.get(fkvkey) || "";
    }
    return decode(index);
}
/** 根据index的获取mapping信息 */ function get(index) {
    var _g___I18N_CACHED_KEY_MAP;
    return ((_g___I18N_CACHED_KEY_MAP = g.__I18N_CACHED.KEY_MAP) === null || _g___I18N_CACHED_KEY_MAP === void 0 ? void 0 : _g___I18N_CACHED_KEY_MAP[index]) || null;
}
/** 将index转成不可见字符 */ function decode(index) {
    return index.toString().split("").map(function(num) {
        return NUM_HIDDEN[num];
    }).join("");
}
/** 将不可见字符转成index */ function encode(str) {
    return str.split("").map(function(cur) {
        return NUM_HIDDEN[cur];
    }).join("");
}
/** 将字符串和信息混入索引和不可见字符 */ function encrypt(str, VK) {
    return "⁯⁯".concat(str, "⁯⁯").concat(set(VK), "⁯⁯");
}
/** 将混有不可见字符的字符串反向解密返回原始字符串和信息 */ function decrypt(str) {
    if (str.includes("⁯⁯")) {
        var spts = str.split("⁯⁯");
        return {
            copy: str.replace(HIDDEN_REG, ""),
            info: spts.length >= 4 ? get(spts[2].split("").map(function(item) {
                return NUM_SHOWED[item];
            }).join("")) : null
        };
    }
    return {
        copy: str,
        info: null
    };
}
/** 将混有不可见字符的字符串反向解密返回原始字符串 */ function getOriginalCopy(str) {
    return str.includes("⁯") ? str.replace(HIDDEN_REG, "") : str;
}
export var i18nMapping = {
    set: set,
    get: get,
    decode: decode,
    encode: encode,
    encrypt: encrypt,
    decrypt: decrypt,
    getOriginalCopy: getOriginalCopy
};
